import React from 'react';
import {
  FaFacebookF,
  FaInstagram,
  FaTiktok,
  FaWhatsapp,
  FaYoutube,
  FaStar,
} from 'react-icons/fa6';
import { SiGooglemybusiness } from 'react-icons/si';
import VisKar from '../assets/img/VisKar QR Youka GmbH.png';

const socialLinks = {
  facebook: 'https://www.facebook.com/youkagmbh',
  instagram: 'https://www.instagram.com/youkagmbh',
  tiktok: 'https://www.tiktok.com/@youkagmbh',
  whatsapp: 'https://wa.me/491604035965',
  youtube: 'https://www.youtube.com/@youkagmbh',
  googleBusiness: 'https://share.google/mOe0aR4AdyHDlkLxr',
  googleReview: 'https://search.google.com/local/writereview?placeid=ChIJscuryPlYPAwRUrn4oiEFTMw',
};

const IconLink = ({ href, label, children }) => (
  <a
    href={href}
    aria-label={label}
    target="_blank"
    rel="noopener noreferrer"
    className="text-gray-300 hover:text-white transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-800 focus-visible:ring-white rounded"
  >
    {children}
  </a>
);

const Footer = () => {
  const currentYear = new Date().getFullYear();

  // دالة تفتح مدير الكوكيز عند النقر
  const openCookieManager = (e) => {
    e.preventDefault();
    window.dispatchEvent(new CustomEvent('cookie-manager', { detail: 'open-cookie-manager' }));
  };

  return (
    <footer className="relative bg-[#103d5b] text-white mt-auto w-full pt-16">
      {/* شريط علوي رمادي ناعم */}
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-none">
        <svg
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
          className="relative block w-[calc(100%+1.30px)] h-[3px] sm:h-[5px]"
        >
          <path d="M1200 120L0 120 0 0 1200 0 1200 120z" className="fill-gray-50" />
        </svg>
      </div>

      <div className="container mx-auto px-6 relative z-10 py-8">
        {/* أيقونات التواصل */}
        <div className="mb-8">
          <div className="flex flex-row flex-wrap items-center justify-center gap-5 text-center pb-6 border-b border-gray-500">
            <IconLink href={socialLinks.facebook} label="Facebook"><FaFacebookF className="text-2xl" /></IconLink>
            <IconLink href={socialLinks.instagram} label="Instagram"><FaInstagram className="text-2xl" /></IconLink>
            <IconLink href={socialLinks.tiktok} label="TikTok"><FaTiktok className="text-2xl" /></IconLink>
            <IconLink href={socialLinks.whatsapp} label="WhatsApp"><FaWhatsapp className="text-2xl" /></IconLink>
            <IconLink href={socialLinks.youtube} label="YouTube"><FaYoutube className="text-3xl" /></IconLink>
            <IconLink href={socialLinks.googleBusiness} label="Google Business">
              <SiGooglemybusiness className="text-2xl text-blue-400" />
            </IconLink>
            <IconLink href={socialLinks.googleReview} label="Bewerten Sie uns auf Google">
              <FaStar className="text-2xl text-yellow-400 hover:text-yellow-500" title="Bewerten Sie uns auf Google ⭐" />
            </IconLink>
          </div>
        </div>

        {/* الأقسام */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center md:text-left lg:ml-7 xl:ml-14">
          {/* القسم 1 */}
          <div className="md:col-span-1 mb-6 md:mb-0">
            <h3 className="text-xl font-bold mb-2">YOUKA GmbH</h3>
            <p className="text-gray-400 text-sm">
              Ihr zuverlässiger Partner für Bauarbeiten und Renovierungen.
            </p>
          </div>

          {/* القسم 2 */}
          <div className="md:col-span-1 lg:ml-11">
            <h4 className="font-semibold mb-4 tracking-wide">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="/" className="text-gray-400 hover:text-white">Home</a></li>
              <li><a href="/UnsereMission" className="text-gray-400 hover:text-white">Unsere Mission</a></li>
              <li><a href="/projekte" className="text-gray-400 hover:text-white">Projekte</a></li>
              <li><a href="/kontakt" className="text-gray-400 hover:text-white">Kontakt</a></li>
            </ul>
          </div>

          {/* القسم 3: Rechtliches + Cookie Einstellungen */}
          <div className="md:col-span-1 lg:ml-14">
            <h4 className="font-semibold mb-4 tracking-wide">Rechtliches</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="/impressum" className="text-gray-400 hover:text-white">Impressum</a></li>
              <li><a href="/datenschutz" className="text-gray-400 hover:text-white">Datenschutz</a></li>
            </ul>

            <div className="mt-6">
  <h5 className="font-semibold mb-1 text-base">Cookie Einstellungen</h5>
  <a
    href="/"
    onClick={(e) => {
      e.preventDefault();
      openCookieManager(e);
    }}
    className="text-[#10a5c7] hover:underline text-sm font-medium"
  >
    Cookie-Einstellungen anpassen
  </a>
</div>

          </div>

          {/* القسم 4 */}
          <div className="md:col-span-1 lg:ml-14">
            <img
              src={VisKar}
              alt="VisKar YOUKA GmbH"
              title="Digitale Visitenkarte"
              className="inline-block align-middle w-40 h-auto object-contain"
            />
          </div>
        </div>

        {/* الأسفل */}
        <div className="mt-12 pt-8 border-t border-gray-500 text-center text-sm text-gray-400">
          <p>&copy; {currentYear} YOUKA GmbH. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
